import * as React from 'react';

import { mergeStyles } from '@cian/utils';

import * as styles from './Image.css';

export interface IImageSimpleProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
  alt?: string;
  loadingStatus?: boolean;
}

export enum LoadingStatus {
  loading = 0,
  loaded = 1,
  error = 2,
}

export interface IImageSimpleState {
  status: LoadingStatus;
}

export class ImageSimple extends React.Component<IImageSimpleProps, IImageSimpleState> {
  public state = {
    status: LoadingStatus.loading,
  };

  public render() {
    const {
      src,
      loadingStatus,
      alt = '',
      // tslint:disable-next-line:trailing-comma
      ...rest
    } = this.props;
    const isLoading = loadingStatus || this.state.status === LoadingStatus.loading;
    const isError = this.state.status === LoadingStatus.error;

    return (
      <div
        {...mergeStyles([
          styles['image'],
          isError && styles['image--error'],
          isLoading && styles['image--loading'],
        ])}
      >

          <div
            className={styles['image-container']}
          >
            <img
              alt={alt}
              src={src}
              ref={this.refCreate}
              onLoad={this.onLoad}
              onError={this.onError}
              {...rest}
            />
          </div>
        {isError &&
          <div className={styles['image-message']}>Ошибка загрузки</div>
        }
      </div>
    );
  }

  private onLoad = (event?: React.SyntheticEvent<HTMLImageElement>) => {
    this.setState({ status: LoadingStatus.loaded });
    if (event && this.props.onLoad) {
      this.props.onLoad(event);
    }
  }

  private onError = (event?: React.SyntheticEvent<HTMLImageElement>) => {
    this.setState({ status: LoadingStatus.error });
    if (event && this.props.onError) {
      this.props.onError(event);
    }
  }

  private refCreate = (element: HTMLImageElement | null) => {
    // element.complete может быть true до вызова onLoad onError и тогда эти методы не вызовутся
    if (element && element.complete && this.state.status === LoadingStatus.loading) {
      if (element.naturalWidth) {
        this.onLoad();
      } else {
        this.onError();
      }
    }
  }
}
